// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomErrorPage_container__fY_Lh","content":"CustomErrorPage_content__5zgVq","logoContainer":"CustomErrorPage_logoContainer__LoZJ4"};